class LicenseExpiredError extends Error {
  constructor(props) {
    super(props);

    this.name = 'LicenseExpiredError';
  }
}

export default LicenseExpiredError;
